interface Contract {
  ID: number;
  status: string;
  contract_name: string;
  sku: string;
  partner_id: number;
}

interface ButtonState {
  label: string;
  disabled: boolean;
}

const productOrder = [
  "ORIGO-TPS-OMI-STARTER", // Builder
  "PS-SUPPORT-T100", // Core
  "PS-SUPPORT-T200", // Advanced
  "PS-SUPPORT-T300", // Premium
];

const BUILDER_SKU = "ORIGO-TPS-OMI-STARTER";

export function getSubscriptionButtonState(
  contracts: Contract[],
  sku: string
): ButtonState {
  const hasScheduled = contracts.some(
    (c) => c.status.toLowerCase() === "scheduled"
  );

  const activeContract = contracts.find(
    (c) => c.status.toLowerCase() === "active"
  );

  // Builder should be disabled if any active subscription exists for Shopify products
  if (
    sku === BUILDER_SKU &&
    activeContract &&
    productOrder.indexOf(activeContract.sku) !== -1
  ) {
    return {
      label: activeContract.sku === sku ? "Active" : "Add to Cart",
      disabled: true,
    };
  }

  // If any Scheduled contracts → lock upgrades/downgrades
  if (hasScheduled) {
    if (activeContract && activeContract.sku === sku) {
      return { label: "Active", disabled: true };
    }

    const isScheduled = contracts.some(
      (c) => c.sku === sku && c.status.toLowerCase() === "scheduled"
    );

    if (isScheduled) {
      return { label: "Scheduled", disabled: true };
    }

    return { label: "Add to Cart", disabled: true };
  }

  // Upgrade/Downgrade control
  if (activeContract) {
    const activeIndex = productOrder.indexOf(activeContract.sku);
    const currentIndex = productOrder.indexOf(sku);

    if (activeIndex === -1 || currentIndex === -1) {
      return { label: "Add to Cart", disabled: false };
    }

    if (currentIndex === activeIndex) {
      return { label: "Active", disabled: true };
    }

    if (currentIndex > activeIndex) {
      return { label: "Upgrade", disabled: false };
    }

    if (currentIndex < activeIndex) {
      return { label: "Downgrade", disabled: false };
    }
  }

  // Default: no active or inactive, allow purchase
  return { label: "Add to Cart", disabled: false };
}
